import axios from "axios";
import * as ActionType from "./delivery.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";

// GET (pagination)
export const getDelivery = (start = 1, limit = 10) => (dispatch) => {
  apiInstanceFetch
    .get(`deliveryService/getDeliveryServices?start=${start}&limit=${limit}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_DELIVERY,
        payload: res.deliveryServices,
      });
    })
    .catch((err) => console.log(err));
};

// CREATE
export const createDelivery = (data) => (dispatch) => {
  axios
    .post(`deliveryService/create`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_DELIVERY,
          payload: res.data.deliveryService,
        });
        setToast("success", res.data.message);
      } else setToast("error", res.data.message);
    })
    .catch((err) => console.log(err));
};

// UPDATE
export const updateDelivery = (data, id) => (dispatch) => {
  axios
    .patch(`deliveryService/update?deliveryServiceId=${id}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_DELIVERY,
          payload: { data: res.data.deliveryService, id },
        });
        setToast("success", res.data.message);
      } else setToast("error", res.data.message);
    })
    .catch((err) => console.log(err));
};

// DELETE
export const deleteDelivery = (id) => (dispatch) => {
  axios
    .delete(`deliveryService/delete?deliveryServiceId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_DELIVERY,
          payload: { id },
        });
        setToast("success", res.data.message);
      } else setToast("error", res.data.message);
    })
    .catch((err) => console.log(err));
};

// TOGGLE
export const toggleDeliveryStatus = (row) => (dispatch) => {
  axios
    .patch(`deliveryService/toggleSwitch?deliveryServiceId=${row._id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.TOGGLE_DELIVERY,
          payload: { data: res.data.deliveryService, id: row._id },
        });

        setToast(
          "success",
          res.data.message
        );
      }
    })
    .catch((err) => console.log(err));
};